
export default {
    name: 'historique-protocole-soins',
    components: {},
    props: {
        historique: Object
    },
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}


